import * as React from 'react'

import { cn } from '@repo/ui/lib/utils'

function PanelHeader({
  children,
  className,
  description,
  title,
}: {
  children?: React.ReactNode
  className?: string
  description?: React.ReactNode
  title: React.ReactNode
}) {
  return (
    <header
      className={cn(
        'flex shrink-0 items-start justify-between gap-3 border-b px-4 py-4',
        className,
      )}
      data-slot="panel-header"
    data-sentry-component="PanelHeader" data-sentry-source-file="panel-header.tsx">
      <div className="min-w-0">
        <h2 className="font-semibold">{title}</h2>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {children}
    </header>
  )
}

export { PanelHeader }
